import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { useConversationKeywordsActions } from '@hooks/settings/conversation-keywords/useConversationKeywordsActions';
import { usePermissions } from '@hooks/usePermissions';
import { usePlatformFeatures } from '@hooks/usePlatformFeatures';
import { useEffect } from 'react';
import { useMainSelector } from '../../useMainSelector';

export const useConversationKeywordsInit = (
  withoutLoadingAnimation = false,
) => {
  const { fetchConversationKeywords } = useConversationKeywordsActions();
  const { hasPermissions } = usePermissions();
  const { hasConversationKeywords } = usePlatformFeatures();
  const {
    conversationKeywords: { keywords },
  } = useMainSelector();

  useEffect(() => {
    // Skip if keywords are already in the store — avoids a redundant request
    // when the user visited the keyword settings page or the checklist first.
    if (keywords.length > 0) {
      return;
    }

    // Both the feature flag and the list permission must be active before fetching
    if (
      hasConversationKeywords &&
      hasPermissions([
        PERMISSIONS.CONVERSATION_KEYWORDS.CONVERSATION_KEYWORDS_LIST,
      ])
    ) {
      fetchConversationKeywords(withoutLoadingAnimation);
    }
  }, [
    fetchConversationKeywords,
    withoutLoadingAnimation,
    hasConversationKeywords,
    hasPermissions,
    keywords.length,
  ]);
};
